import { render, staticRenderFns } from "./FormVansales.vue?vue&type=template&id=532d52a2&scoped=true"
import script from "./FormVansales.vue?vue&type=script&lang=js"
export * from "./FormVansales.vue?vue&type=script&lang=js"
import style0 from "./FormVansales.vue?vue&type=style&index=0&id=532d52a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532d52a2",
  null
  
)

export default component.exports